import React from "react"
import { useState, useEffect } from "react"
import { Input } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { alertService } from '../../services/helpers/alert.service';
import { partnerService } from '../../services/api/partner.service';
import { nomService } from '../../services/api/nom.service';
import { CustomUpload } from "../shared/customUpload";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";


export const FileListAddFile = (props) => {
    const toggleDialog = props.toggleDialog;

    const partener = sessionStorage.getItem("idPartener");

    const [dropdown, setDropdown] = useState([]);
    const [file, setFile] = useState();
    const [fileType, setFileType] = useState();
    const [description, setDescription] = useState("");

    const handleDropdownChange = (event) => {
        setFileType(event.value);
    }

    const handleFileLoad = (event) => {
        setFile(event.value);
    }

    useEffect(() => {
        nomService.getFileTypes().then(response => {
            if (response) {
                setDropdown(response);
            }

        });

    }, []);

    const handleSubmit = async (event) => {

        event.preventDefault();

        if (!description) {
            alertService.error("Campul descriere este obligatoriu!");
            return;
        }
        if (!fileType) {
            alertService.error("Campul tip fisier este obligatoriu!");
            return;
        }

        if (!file || file.length == 0) 
        {
            alertService.error("Nu ati selectat nici un fisier!");
            return;
        }

        const formData = new FormData();
        formData.append('Description', description);
        formData.append('FileType', fileType?.id);
        formData.append('File', file[0].getRawFile());
        formData.append('Partener', partener);

        partnerService.uploadFile(formData)
            .then(response => {
                if (response) {
                    if (response.message) {
                        alertService.success(response.message);
                    }

                    toggleDialog();
                }
            });
    }


    return (
        <>
            <Dialog title={"Adauga fisier"} onClose={toggleDialog}>

                <h2 className="titlu">Adauga fisier</h2>
                <div name="div_date">
                    <form className="formular" name="form_file" onSubmit={handleSubmit} >
                        <fieldset>
                            <div className="clearfix pb10">
                                <label className="pb5">Descriere fisier <span className="red">*</span>:</label>
                                <Input name="descriere"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>

                            <div className="clearfix pb10">
                                <label className="pb5">Fisier:</label>
                                <CustomUpload
                                    value={file}
                                    onChange={handleFileLoad}
                                />
                            </div>

                            <div className="clearfix pb10">
                              
                                <div name="fisier_dddw">
                                    <DropDownList
                                        className="full"
                                        name="tip_fisier"
                                        data={dropdown}
                                        textField="text"
                                        dataItemKey="id"
                                        onChange={handleDropdownChange}
                                    />
                                </div>
                            </div>
                        </fieldset>
                    </form>

                </div>

                <DialogActionsBar>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={handleSubmit}
                    >
                        Salveaza
                    </button>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={toggleDialog}
                    >
                        Inchide
                    </button>
                </DialogActionsBar>
            </Dialog>
        </>
    );
}